export const footerItems = [
  {
    label: 'API Portal',
    field: 'apiPortalLink',
    url: '',
    show: false,
  },
  {
    label: 'Contact Us',
    field: 'contactUs',
    url: '/contact-us',
    show: true,
  },
  {
    label: 'FAQs',
    field: 'faq',
    url: '',
    show: false,
  },
  {
    label: 'About Us',
    field: 'aboutUs',
    url: '/about-us',
    show: true,
  },
  {
    label: 'Terms of Use',
    field: 'termsAndConditions',
    url: '/terms-of-use',
    show: true,
  },
  {
    label: 'Privacy Policy',
    field: 'privacyPolicy',
    url: '/privacy-policy',
    show: true,
  },
];
